import { Model, RailsFormat } from "./model";

export class Address extends Model implements RailsFormat {

  constructor(
    public id?: number,
    public contactId?: number,
    public label: string = "",
    public lineOne: string = "",
    public lineTwo: string = "",
    public state: string = "",
    public suburb: string = "",
    public postcode: string = "",

    public uiState: any = {},
  ) { super(); }

  static clone(obj: any) {
    const address: Address = new this();

    if (obj.id) { address.id = obj.id }
    if (obj.contactId) { address.contactId = obj.contactId }
    if (obj.label) { address.label = obj.label }
    if (obj.lineOne) { address.lineOne = obj.lineOne }
    if (obj.lineTwo) { address.lineTwo = obj.lineTwo }
    if (obj.state) { address.state = obj.state }
    if (obj.suburb) { address.suburb = obj.suburb }
    if (obj.postcode) { address.postcode = obj.postcode }

    if (obj.errors && Object.keys(obj.errors).length > 0) {
      address.errors = Model.getJsonApiErrors(obj.errors)
    }

    if (obj.uiState) { address.uiState = obj.uiState }

    return address;
  }

  serializeForRails() {
  }

  getFinalAddressLine() {
    const populatedItems: string[] = [];

    if (this.suburb) { populatedItems.push(this.suburb) }
    if (this.state) { populatedItems.push(this.state) }
    if (this.postcode) { populatedItems.push(this.postcode) }

    return populatedItems.join(", ");
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/address.ts